import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom'
import { RedocStandalone } from 'redoc';

import { options as redocOptions } from '../ReDocResources/options';
import { getUrlPath } from '../../utils';
import '../ReDocResources/ReDoc.scss';

export function ReDoc(props) {
	const [specUrl, setSpecUrl] = useState(undefined);

	const apiName = props.match.params.name;
	const apiMatch = props.apis.find(api => getUrlPath(api.name) === apiName);

	useEffect(() => {
		if (apiMatch) {
			fetch(apiMatch.url)
				.then(resp => resp.json())
				.then(data => {					
					data.info.description = 'Storm API documentation to operate Atlas meters.';
	
					setSpecUrl(data);
				});
		}
	}, [apiMatch]);

	if (!apiMatch) {
		return <Redirect to='/not-found' />
	}

	if (!specUrl) {
		return <></>;
	}

	return (
		<RedocStandalone
			specUrl={specUrl}
			options={redocOptions}
		/>
	);
}